import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { APP } from 'pricing-pages-ui/constants/tracking/Locations';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suitePurchaseMotionsMapSelector } from '../../selectors/PurchaseMotionSelectors';
import { upgradeProductSelector } from '../../selectors/ProductsSelectors';
import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import PriceDisplay from '../common/pricing/PriceDisplay';

const StarterSuiteGWPPromotionBanner2023Q3 = ({
  screen
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel: STARTER
  }));
  const price = useSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    return calculatedPriceSelector(state, {
      productConfigurations: suiteProductConfigurations,
      useHighestSuiteOfferTerms: true
    }).monthly.calculatedPrice;
  });
  const suitePurchaseMotions = useSelector(state => suitePurchaseMotionsMapSelector(state)[STARTER] || []);
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: suiteProductConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const sourceId = 'starter-suite-gwp-promotion-banner-q3-2023';
  const upgradeData = {
    app: APP,
    screen,
    upgradeProduct,
    uniqueId: `${sourceId}`
  };
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "starterSuiteGWPQ32023Promotion.title"
    }),
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: 'starterSuiteGWPQ32023Promotion.body_jsx',
        elements: {
          Price: PriceDisplay
        },
        options: {
          currencyCode,
          price
        }
      }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
        authedComponentLoader: () => import(
        /* webpackChunkName: "authed-chunk" */
        `pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
        authedComponentProps: {
          use: 'tertiary',
          level: 1,
          productConfigurations: suiteProductConfigurations,
          purchaseMotions: suitePurchaseMotions,
          trackingSource: sourceId,
          queryParamTerm: ANNUAL,
          upgradeData,
          currencyCode,
          style: {
            padding: '5px 12px',
            fontWeight: 400,
            fontSize: '12px'
          }
        }
      })]
    })
  });
};

export default StarterSuiteGWPPromotionBanner2023Q3;